"use client";
'use strict';

var React = require('react');
var usePrevious = require('./usePrevious.js');

/**
 * This hook allows you to debounce any fast changing value.
 *
 * @param value the value to execute
 * @param delay the delay (in ms)
 * @example
 * ```javascript
 * const [innerValue, setInnerValue] = React.useState<number>(value)
 * const debouncedInnerValue = useDebounce<number>(innerValue, 300)
 * ```
 */
function useDebounceValue(value, delay) {
    // State and setters for debounced value
    const [debouncedValue, setDebouncedValue] = React.useState(value);
    // Prevent first render
    const previous = usePrevious.usePrevious(debouncedValue);
    React.useEffect(() => {
        // Update debounced value after delay
        const handler = setTimeout(() => {
            if (previous !== value) {
                setDebouncedValue(value);
            }
        }, delay);
        // Cancel the timeout if value changes (also on delay change or unmount)
        // This is how we prevent debounced value from updating if value is changed ...
        // .. within the delay period. Timeout gets cleared and restarted.
        return () => {
            clearTimeout(handler);
        };
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [value, delay]);
    return debouncedValue;
}

exports.useDebounceValue = useDebounceValue;
//# sourceMappingURL=useDebounceValue.js.map
